import { Link } from "@/lib/nav";
import { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { listHref } from "@buildpy/core/modules/list/search";

export interface ViewSwitchItem {
  // 쿼리 값 — null 이면 파라미터를 뺀 기본값.
  value: string | null;
  label: ReactNode;
}

interface Props {
  path: string;
  items: readonly ViewSwitchItem[];
  current: string | null;
  "aria-label": string;
  // 바꿀 쿼리 파라미터 이름(기본 view).
  param?: string;
  // 그대로 둘 다른 파라미터(q·status 등) — page 는 늘 첫 쪽으로 돌린다.
  keep?: Record<string, string | number | null | undefined>;
  className?: string;
  testId?: string;
}

// URL 쿼리 하나를 고르는 붙은 세그먼트 — 목록·달력·차트 같은 보기 전환, 「내 담당·전체」 같은 범위 전환에 쓴다.
const ViewSwitch = ({ path, items, current, "aria-label": ariaLabel, param = "view", keep = {}, className, testId }: Props) => (
  <nav
    aria-label={ariaLabel}
    className={cn("inline-flex shrink-0 overflow-hidden rounded-md border border-input", className)}
    data-testid={testId}>
    {items.map((item, i) => {
      const active = item.value === current;
      return (
        <Link
          key={item.value ?? ""}
          aria-current={active ? "page" : undefined}
          className={cn(
            "flex h-9 items-center whitespace-nowrap px-3.5 text-sm",
            i > 0 && "border-l border-input",
            active ? "bg-primary font-medium text-primary-foreground" : "bg-background text-muted-foreground hover:bg-muted"
          )}
          href={listHref(path, { ...keep, page: null, [param]: item.value })}>
          {item.label}
        </Link>
      );
    })}
  </nav>
);

export default ViewSwitch;
